const getOrgContractQuery = (additionalFields = '') => `
query(
  $effectiveDate: Date!
  $salesChannel: SalesChannelType
  $lang: Language!
) {
  organizationContractProductConfigurations(
    effectiveDate: $effectiveDate
    salesChannel: $salesChannel
  ) {
      salesChannel
      plan {
        code
        planType
        planClass
        content(lang: $lang) {
          name
          code
          lang
          summary
          details
          eligibility
          exclusion
          deductibles
          tripDays
          coverageAmounts
          sumInsuredAfterNeeded
          mostPopular
          tripCancellation
          tripInterruption
          emmergencyMedical
          travelAccident
          flightAccident
          baggageDelay
          baggageLoss
          raiders
          pdfLink {
            effectiveDate
            factSheetPdfLink
            factSheetPdfLinkText
            noticeOfRecissionPdfLink
            noticeOfRecissionPdfLinkText
            policyPdfLink
            policyPdfLinkText
            productPdfLink
            productPdfLinkText
            cmProductPdfLink
          }
          exclusions {
            exclusionDescription
            maxAge
            minAge
            minCoverage
            maxCoverage
            rateCategory
            exclusionType
          }
          tooltips {
            deductible
            tripCost
            tripDuration
            coverageAmount
          }
        }
        benefits(createDate: $effectiveDate) {
          code
          benefitType
          content(lang: $lang) {
            name
            code
            lang
            summary
            details
            deductibles
            tripDays
            sumInsuredAfterNeeded
          }
          configs {
            config {
              ... on BenefitConfig {
                eligibilityOpts {
                  type
                  maxValue
                  minValue
                }
                isPostDepartureDurationDecreaseAllowed
                isPreDepartureDurationDecreaseAllowed
                planCancellableAfterFreeLook
                rules {
                  type
                  isPreDepartureIncreaseAllowed
                  isPostDepartureIncreaseAllowed
                  isPreDepartureDecreaseAllowed
                  isPostDepartureDecreaseAllowed
                }
              }
            }
          }
        }
        ${additionalFields}
      }
    }
  }
`;

export const ORGANIZATION_CONTRACT_QUERY = getOrgContractQuery();

export const ORGANIZATION_CONTRACT_WITH_CONFIG_QUERY = getOrgContractQuery(`
configs {
  ownerCode
  config {
    ... on PlanConfig {
      questionnaireOptions{
        minAgeUnit
        minAgeUnitType
      }
      tripDurationByAges {
        maxAgeUnit
        maxAgeUnitType
        maxDurationUnit
        maxDurationUnitType
        minAgeUnitType
        minAgeUnit
        minDurationUnit
        minDurationUnitType
      }
      tripDurations {
        maxTripDurationUnit
        maxTripDurationUnitType
        minTripDurationUnit
        minTripDurationUnitType
      }
    }
  }
}`);

export const NEED_ANALYSIS_QUERY = `
query($planClass: String! $effectiveDate: Date! $lang: Language!) {
  medicalQuestionnaire(planClass: $planClass effectiveDate: $effectiveDate lang: $lang) {
    pages {
      pageNumber
      lang
      description
      sections {
        order
        description
        lang
        questions {
          questionKey
          questionText
          answerType
          order
          lang
        }
      }
    }
  }
}
`;

export const LOCATION_QUERY = `
query($where: JSON $limit: Int $groupBy: String!) {
  distinctTravelLocations(where: $where limit:$limit groupBy: $groupBy) {
    id
    iata
    name
    city
    state
    country
  }
}
`;

export const PROFILE_ORG_CODE = `
query($profileRef: String) {
  profiles(where: { profileRef: $profileRef }) {
    organizationCode
  }
}
`;

export const PLAN_NAME_QUERY = `
query Query($lang: Language!, $where: JSON) {
  plans(where: $where) {
    code
    content(lang: $lang) {
      name
    }
  }
}`;

export const ORG_SERVICE_KEY = `
query($where: JSON) {
  profiles(where: $where) {
    organizationCode
    salesChannel
    profileRef
  }
}
`;

export const GET_PROFILES_QUERY = `query($where: JSON) {
  profiles(where: $where) {
    id
    organizationCode
    agentId
    user {
      firstName
      lastName
      email
      role
      language
      province
      userRef
    }
    status
    agencyCode
    sellerCode
  }
}`;

export const getProfile = `
  query Query($where: JSON) {
    profiles(where: $where) { profileRef }
  }
`;

export const getUserRoles = `
  query Query($where: JSON) {
    userRoles(where: $where) {
      profileRef
    }
  }
`;

export const createUser = `
  mutation CreateUserMutation($createUserInput: CreateUserInput!) {
    createUser(input: $createUserInput) { id }
  }
`;

export const createProfile = `
  mutation CreateProfileMutation($createProfileInput: CreateUserProfileInput!) {
    createUserProfile(input: $createProfileInput) { id }
  }
`;

export const createUserRole = `
  mutation CreateUserRoleMutation($createUserRoleInput: CreateUserRoleInput!) {
    createUserRole(input: $createUserRoleInput) { profileRef }
  }
`;

export const UPDATE_PROFILE_QUERY = `mutation updateProfile($updateProfileId: ID!, $updateProfileInput: UpdateProfileInput!) {
  updateProfile(id: $updateProfileId, input: $updateProfileInput) {
    organizationCode
    agentId
    user {
      firstName
      lastName
      email
      role
      language
      province
    }
    status
    agencyCode
    sellerCode
    profileRef
  }
}`;

export const UPDATE_USER_QUERY = `mutation UpdateUser($updateUserInput: UpdateUserInput!, $userRef: String!) {
  updateUser(input: $updateUserInput, userRef: $userRef) { id }
}`;

export const TRAVEL_LOCATIONS_QUERY = `
  query TravelLocations($where: JSON) {
    travelLocations(limit:1000,where: $where) {
      name
      country
      iata
    }
  }
`;
